import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../constants';
import { Title } from '../Title';
import { Text } from '../Text';
import { InfoSection } from '../InfoSection';

interface IProps {
    className?: string;
}

const BaseLifestyleSection = ({ className }: IProps) => (
    <InfoSection
        imageUrl="https://grandvision.s3.amazonaws.com/pnl/images/online-oogcheck/result-lifestyle.jpg"
        bgColor={colors.greenPrimary}
        className={className}
    >
        <Title>Lifestyle</Title>
        <Text>
            Jouw lifestyle heeft impact op jouw zicht en jouw zichtoplossing
            moet volledig passen bij jouw lifestyle. Onze vakkundige opticiens
            gaan met jou in gesprek over jouw leven en jouw lifestyle.
        </Text>
        <Text>
            Zo kan roken en veelvuldig beeldschermgebruik impact hebben op je
            zicht. En bij iemand die een actieve levensstijl heeft, past weer
            een andere zichtoplossing dan bij iemand die dat niet heeft.
        </Text>
    </InfoSection>
);

export const LifestyleSection = styled(BaseLifestyleSection)`
    ${Title} {
        margin-bottom: 40px;
    }

    ${Text} {
        margin: 20px 0;
    }
`;
